// src/js/components/genericModal.js
import { activateTrap, deactivateTrap } from '../utils/focusTrap.js';

export function initializeGenericModals() {
    const openTriggers = document.querySelectorAll('[data-modal-target]');
    if (openTriggers.length === 0) return;

    let activeModalElement = null;
    let originalTrigger = null;

    const closeModal = () => {
        if (!activeModalElement) return;
        deactivateTrap();
        if (originalTrigger) originalTrigger.focus(); // Flyttar tillbaka fokus

        activeModalElement.classList.remove('is-visible');
        activeModalElement.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('modal-open');
        
        activeModalElement = null;
        originalTrigger = null;
    };

    openTriggers.forEach(trigger => {
        const modalId = trigger.dataset.modalTarget;
        const modal = document.getElementById(modalId);
        if (!modal) return;

        const closeButtons = modal.querySelectorAll('.close-button');

        trigger.addEventListener('click', (event) => {
            event.preventDefault();
            activeModalElement = modal;
            originalTrigger = trigger; 
            
            modal.classList.add('is-visible');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('modal-open');
            
            activateTrap(modal);
            if (closeButtons.length > 0) closeButtons[0].focus();
        });

        closeButtons.forEach(button => {
            button.addEventListener('click', closeModal);
        });

        modal.addEventListener('click', (event) => {
            if (event.target === modal) closeModal();
        });
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && activeModalElement) {
            closeModal();
        }
    });
}